<template lang='pug'>
  i.svg-icon.svg-icon-tag
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M27.426,85.02l3.271-19.352H20.505v-9.946h12.206l2.014-12.108H24.028V33.56h12.458l3.146-18.811h11.2L47.686,33.56h11.452 l3.271-18.811h11.199L70.337,33.56h10.067v10.054H68.575l-2.014,12.108h10.445v9.946H64.674L61.528,85.02H50.202l3.146-19.352 H41.897L38.751,85.02H27.426z M55.362,55.722l2.014-12.108H45.924L43.91,55.722H55.362z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>